module.exports = __webpack_public_path__ + "img/bg-about-sec2.4d67a00d.png";